module.exports = __webpack_public_path__ + "static/img/landing-x.0fada6c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/landing-x.png
// module id = lQYp
// module chunks = 1